import React from 'react';
import PropTypes from 'prop-types';
import StatusPill from './pill/StatusPill';
import { PILL_SIZES } from './pill/tones';

// Assigned and In progress share the progress tone — both mean the task is moving — and the
// icon is what separates them.
const STATUS_CONFIG = {
  assigned: { label: 'Assigned', tone: 'progress' },
  unassigned: { label: 'Unassigned', tone: 'neutral' },
  in_progress: { label: 'In progress', tone: 'progress', icon: 'bi-circle-half' },
  completed: { label: 'Completed', tone: 'success', icon: 'bi-check-lg' },
};

export default function TaskStatusBadge({ status, size, className }) {
  const config = STATUS_CONFIG[status];
  if (!config) return null;

  return (
    <StatusPill tone={config.tone} icon={config.icon} size={size} className={className}>
      {config.label}
    </StatusPill>
  );
}

TaskStatusBadge.propTypes = {
  status: PropTypes.oneOf(['assigned', 'unassigned', 'in_progress', 'completed']).isRequired,
  size: PropTypes.oneOf(PILL_SIZES),
  className: PropTypes.string,
};

TaskStatusBadge.defaultProps = {
  size: 'standalone',
  className: '',
};
